import { createContext } from 'react';
import type { ResolvedTheme, ThemePreference } from '../lib/theme';

export interface ThemeContextValue {
  /** What the user picked on this device. */
  preference: ThemePreference;
  /** What is on screen: the preference with `system` worked out. */
  theme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
